module.exports = __webpack_public_path__ + "static/media/505.ceacba9d.svg";